module.exports = __webpack_public_path__ + "media/src/images/invoease-dark-3e1bdd3442c6b548060967a6c8441cf9.svg";